export default __webpack_public_path__ + "static/media/jea2.a2afcdb1.png";